module.exports = __webpack_public_path__ + "static/media/search_ic.a7a6b92f.svg";